import { useCallback, useContext } from 'react'
import { ClientTabRequirementsContext } from './clientTabRequirementsContext'
import type { ClientTabField } from './clientTabStatus'

const useClientTabMissingFields = () => {
  const { missingFields } = useContext(ClientTabRequirementsContext)

  return useCallback((field: ClientTabField) => missingFields.has(field), [missingFields])
}

export default useClientTabMissingFields
